import {
    REORDER_TEMPLATES,
} from "template-edit/reducers"
import {
    reorderTemplates as apiReorderTemplates
} from "app/helpers/api"
import {
    put,
    takeEvery,
} from "redux-saga/effects"
import _find from "lodash/find";
import {Template} from "app/types/model-types";

/**
 * Saga that defines what happens when user clicks on duplicate template button
 * @param action
 */
export function* reorderTemplates(action) {
    const { order, templates } = action.payload

    let orderedTemplates = [];
    order.forEach((templateId, i) => {
        const template = _find(templates.data, (template: Template) => {
            return `${template.id}` === `${templateId}`
        })
        orderedTemplates.push({...template, priority: i+1})
    })

    yield put({
        type: REORDER_TEMPLATES.STARTED,
        payload: orderedTemplates
    })

    try {
        // makes the request
        let { data } = yield apiReorderTemplates(order)
        // dispatch REORDER_TEMPLATES.SUCCESS
        yield put({
            type: REORDER_TEMPLATES.SUCCESS,
            payload: data,
        })
    } catch (err) {
        // dispatch REORDER_TEMPLATES.ERROR
        yield put({
            type: REORDER_TEMPLATES.ERROR,
            error: err
        })
    }
}

export function* watchReorderTemplates() {
    yield takeEvery(REORDER_TEMPLATES.CREATE, reorderTemplates)
}